import { useState, useEffect, useCallback } from 'react'
import { ProductInfo } from '../types'

interface UseProductInfoProps {
  selectedProductsInfo?: { [key: string]: ProductInfo }
  onSelectedProductsInfoChange?: (info: { [key: string]: ProductInfo }) => void
}

export const useProductInfo = ({ 
  selectedProductsInfo, 
  onSelectedProductsInfoChange 
}: UseProductInfoProps) => {
  const [localProductsInfo, setLocalProductsInfo] = useState<{ [key: string]: ProductInfo }>(
    selectedProductsInfo || {}
  )

  // Sync external selectedProductsInfo changes
  useEffect(() => {
    if (selectedProductsInfo) {
      setLocalProductsInfo(selectedProductsInfo)
    }
  }, [selectedProductsInfo])

  // Helper function to update product info
  const updateProductInfo = useCallback((productValue: string, productData: ProductInfo) => {
    console.log('💾 updateProductInfo called:', { productValue, productData })
    
    setLocalProductsInfo(prevInfo => {
      const newInfo = {
        ...prevInfo,
        [productValue]: productData
      }
      console.log('💾 New localProductsInfo:', newInfo)
      
      // Call external callback if provided
      if (onSelectedProductsInfoChange) {
        onSelectedProductsInfoChange(newInfo)
      }
      
      return newInfo
    })
  }, [onSelectedProductsInfoChange])

  // Helper function to remove product info
  const removeProductInfo = useCallback((productValue: string) => {
    console.log('🗑️ removeProductInfo called:', productValue)
    
    setLocalProductsInfo(prevInfo => {
      const newInfo = { ...prevInfo }
      delete newInfo[productValue]
      console.log('🗑️ New localProductsInfo after removal:', newInfo)
      
      // Call external callback if provided
      if (onSelectedProductsInfoChange) {
        onSelectedProductsInfoChange(newInfo)
      }
      
      return newInfo
    })
  }, [onSelectedProductsInfoChange])

  // Batch update multiple products
  const updateMultipleProductInfo = useCallback((products: { [key: string]: ProductInfo }) => {
    setLocalProductsInfo(prevInfo => {
      const newInfo = { ...prevInfo, ...products }
      
      if (onSelectedProductsInfoChange) {
        onSelectedProductsInfoChange(newInfo)
      }
      
      return newInfo
    })
  }, [onSelectedProductsInfoChange])

  return {
    localProductsInfo,
    updateProductInfo,
    removeProductInfo,
    updateMultipleProductInfo
  }
} 